<div class="app-root-inner" [ngClass]="{'night-mode': !isDayMode }">
  <div class="app-shell">
    <app-header></app-header>

    <router-outlet></router-outlet>

    <app-footer></app-footer>
  </div>
</div>
